import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTopOnMount() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollSmoothlyToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };

    // Espera alguns frames e garante que o conteúdo está pronto
    const rafId = requestAnimationFrame(() => {
      setTimeout(scrollSmoothlyToTop, 100);
    });

    return () => cancelAnimationFrame(rafId);
  }, [pathname]);

  return null;
}

export default ScrollToTopOnMount;